import { render, staticRenderFns } from "./clientCommission.vue?vue&type=template&id=3dab7c54&"
import script from "./clientCommission.vue?vue&type=script&lang=js&"
export * from "./clientCommission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports